import { Link } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { userActions, alertActions } from '_store';
import { HEULIEZ_Logo_White, IVECO_BUS_Logo_WHITE_web } from 'assets/img/partnersLogo';

export { ResetPassword };

function ResetPassword() {
    const dispatch = useDispatch();

    // form validation rules 
    const validationSchema = Yup.object().shape({
        username: Yup.string()
            .required('Nom d\'utilisateur requis'),
    });
    const formOptions = { resolver: yupResolver(validationSchema) };

    // get functions to build form with useForm() hook
    const { register, handleSubmit, formState } = useForm(formOptions);
    const { errors, isSubmitting } = formState;

    async function onSubmit(data) {
        dispatch(alertActions.clear());
        try {
            await dispatch(userActions.resetPassword(data)).unwrap();
        
            dispatch(alertActions.success({ message: 'Un nouveau mot de passe vous a été envoyé, veuillez vérifier votre boite mail.', showAfterRedirect: true }));
        } catch (error) {
            dispatch(alertActions.error(error?.message));
        }
    }

    return (
        <div className="reset-password-container">
            <div className="reset-password-wrapper card">
                <div className="card-header">
                    <div className="nav-icon-container">
                        <img src={IVECO_BUS_Logo_WHITE_web} alt="Logo Iveco" className="nav-icon bordered-icon" />
                        <img src={HEULIEZ_Logo_White} alt="Logo Heuliez" className="nav-icon-small" />                
                    </div>
                <h4 className="font-bold my-auto">Réinitialiser mon mot de passe</h4>  
                </div>              
                <div className="card-body w-[80%] m-auto">
                    <p className='m-4 text-center'>Veuillez renseigner votre nom d'utilisateur. 
                        <br />S'il existe dans la base de données, vous recevrez un nouveau mot de passe par email.
                    </p>
                    <form onSubmit={handleSubmit(onSubmit)}>                    
                        <div className="mb-12 ">
                            <label className="form-label font-bold">Nom d'utilisateur</label>
                            <input name="username" type="text" {...register('username')} className={`form-control ${errors.username ? 'is-invalid' : ''} `} />
                            <div className="invalid-feedback">{errors.username?.message}</div>
                        </div>                         
                        <div className="btn-container my-4">
                            <Link to="../login" className="btn btn-custom btn-custom-secondary">Retour</Link>
                            <button disabled={isSubmitting} className="btn btn-custom btn-custom-primary">
                                {isSubmitting && <span className="spinner-border spinner-border-sm me-1"></span>}
                                Réinitialiser mon mot de passe
                            </button>
                        </div>                      

                    </form>
                </div>
            </div>
        </div>
    )
}
